import classNames from 'classnames';

import styles from './SustainabilityLights.module.scss';

const SystainabilityLightsSkeleton = () => {
    return (
        <div className={styles.Lights}>
            {Array.from({ length: 10 }).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <span className={classNames(styles.Light, styles.LightSkeleton)} key={index} />
            ))}
        </div>
    );
};

export default SystainabilityLightsSkeleton;
